import ObserverClient from './observer-client';

import type { ObserverClient as ObserverClientType } from '@shared/types/frontend/observer-client';
import type { Environment } from '@shared/types/utils';

type Props = {
  environment: Environment;
};

const buildObserverClient = ({ environment }: Props): ObserverClientType => {
  if (environment === 'development') {
    return ObserverClient({
      destinations: ['console'],
    });
  }

  if (environment === 'production') {
    return ObserverClient({ destinations: ['observer'] });
  }

  return ObserverClient({ destinations: ['console', 'event'] });
};

export default buildObserverClient;
